<div class="reportes-wrapper">

  <div class="row mt-2">
    <div *ngFor="let chart of dashboard.CHARTS" class="col-md-6">
      <app-echart [tipo]="chart.SYS19CON" [parametros]="parametros"></app-echart>
    </div>
  </div>

  <div class="row mt-3 g-3" *ngIf="reportes.length > 0; else sinReportes">

    <div class="col-12 col-lg-4">
      <div class="reportes-section">
        <div class="section-header">
          <div class="section-title">
            <i class="fas fa-file-alt"></i>
            <span>Reportes</span>
            <span class="badge-count">{{ reportes.length }}</span>
          </div>
          <div class="section-search" *ngIf="reportes.length > 6">
            <i class="fas fa-search"></i>
            <input type="text" [(ngModel)]="searchTerm" placeholder="Buscar..." />
            <button *ngIf="searchTerm" type="button" class="clear-btn" (click)="searchTerm = ''" title="Limpiar">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div class="reportes-grid reportes-grid--single-col">
          <div *ngFor="let r of reportesFiltrados()"
               class="report-card"
               [class.active]="reporteSel === r"
               role="button"
               tabindex="0"
               (click)="seleccionarReporte(r)"
               (keyup.enter)="seleccionarReporte(r)"
               (keyup.space)="seleccionarReporte(r)">
            <div class="report-card-icon">
              <i class="fas fa-file-invoice"></i>
            </div>
            <div class="report-card-body">
              <div class="report-card-title" [title]="r.SYS10DES">{{ r.SYS10DES }}</div>
              <div class="report-card-meta" *ngIf="r.SYS10CON">
                <span class="meta-pill">{{ r.SYS10CON }}</span>
              </div>
            </div>
            <div class="report-card-check">
              <i class="fas fa-check-circle"></i>
            </div>
          </div>

          <div *ngIf="reportesFiltrados().length === 0" class="reportes-empty">
            <i class="fas fa-inbox"></i>
            <p>No se encontraron reportes con "{{ searchTerm }}"</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-8">
      <div class="filtros-panel">
        <div *ngIf="!reporteSel" class="empty-state">
          <i class="fas fa-hand-pointer"></i>
          <p>Selecciona un reporte para ver sus parámetros</p>
        </div>

        <ng-container *ngIf="reporteSel">
          <div class="filtros-header">
            <i class="fas fa-sliders-h"></i>
            <span>Parámetros — {{ reporteSel.SYS10DES }}</span>
          </div>

          <app-filtrocampo-inline [TipoPantalla]="TipoPantalla"
                                  *ngIf="reporteActivo"
                                  [form_template]="filtrosReporte"
                                  [AccionesOnChange]="AccionesOnChange"
                                  [SYS02CON]="SYS02CON"
                                  [reporteSel]="reporteSel"></app-filtrocampo-inline>

          <div class="actions-bar mt-3" *ngIf="isImprimir">
            <div class="format-group">
              <span class="format-label">Generar como:</span>
              <div class="format-pills" role="group">
                <button type="button"
                        class="format-pill"
                        (click)="seleccionarFormato('PDF')"
                        title="Generar PDF">
                  <i class="fas fa-file-pdf"></i> PDF
                </button>
                <button type="button"
                        class="format-pill"
                        (click)="seleccionarFormato('XLS')"
                        title="Descargar Excel">
                  <i class="fas fa-file-excel"></i> Excel
                </button>
                <button type="button"
                        class="format-pill"
                        (click)="seleccionarFormato('NAV')"
                        title="Abrir en navegador">
                  <i class="fas fa-external-link-alt"></i> Abrir en Navegador
                </button>
              </div>
            </div>
            <div class="actions-buttons">
              <button type="button"
                      [ngClass]="this.favorito_pantalla == 'N' ? 'btn btn-label waves-light' : 'btn btn-warning btn-label waves-light'"
                      [style]="this.favorito_pantalla == 'N' ? 'background-color: #6c757d; color: #ffffff; border-color: #6c757d;' : ''"
                      (click)="GrabarFavorito()" title="Favoritos">
                <i [ngClass]="this.favorito_pantalla == 'N' ? 'far fa-star label-icon' : 'fas fa-star label-icon'"></i>
                Favoritos
              </button>

              <button type="button" title="Limpiar" (click)="reiniciarFormulario()"
                      class="btn btn-label waves-light"
                      style="background-color: #6c757d; color: #ffffff; border-color: #6c757d;">
                <i class="fas fa-broom label-icon"></i>
                Limpiar
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

  </div>

  <ng-template #sinReportes>
    <div class="row mt-3">
      <app-filtrocampo-inline [TipoPantalla]="TipoPantalla"
                              [form_template]="filtrosReporte"
                              [AccionesOnChange]="AccionesOnChange"
                              [SYS02CON]="SYS02CON"
                              [reporteSel]="reporteSel"></app-filtrocampo-inline>
    </div>
  </ng-template>

  <div class="viewer-modal-overlay"
       *ngIf="base64 != ''"
       (click)="cerrarVisor()"
       (keydown.escape)="cerrarVisor()"
       tabindex="0">
    <div class="viewer-modal" (click)="$event.stopPropagation()">
      <div class="viewer-modal-header">
        <div class="viewer-modal-title">
          <i class="fas fa-file-pdf"></i>
          <span>{{ reporteSel?.SYS10DES || 'Vista previa del reporte' }}</span>
        </div>
        <button type="button" class="viewer-modal-close" (click)="cerrarVisor()" title="Cerrar (Esc)">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="viewer-modal-body">
        <report-viewer [ReportData]="base64" [tipoDocumento]="'data:application/pdf'"></report-viewer>
      </div>
    </div>
  </div>

</div>
